module.exports = __webpack_public_path__ + "img/vertical_7_2_3016.55248c7c.png";